// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const snom: PokeData = {
  "id": 872,
  "name": "snom",
  "height": 3,
  "weight": 38,
  "base_experience": 37,
  "types": [
    PokeType.ICE,
    PokeType.BUG
  ],
  "api_moves": [
    "powder-snow",
    "struggle-bug"
  ],
  "moves": [
    "infest",
    "pounce",
    "icicle-dagger",
    "signal-spam",
    "ice-wave",
    "avalanche",
    "bug-buzz",
    "ice-punch",
    "aurora-veil",
    "leech-steal",
    "lunge",
    "string-shot",
    "ice-shard"
  ],
  "evolution_chain": {
    "id": 455,
    "item": null,
    "species": [
      {
        "name": "snom",
        "order": 872,
        "types": [
          PokeType.ICE,
          PokeType.BUG
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "frosmoth",
        "order": 873,
        "types": [
          PokeType.ICE,
          PokeType.BUG
        ],
        "evolves_from_species_id": 872,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": 160,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "night",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 31.25,
    "speed": 20,
    "ability_power": 45
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
